import { State, Selector, Action, StateContext } from '@ngxs/store';
import { tap, catchError } from 'rxjs/operators';
import { RoleModel } from '@core/services/api.service';
import { LoadRolesAction, LoadRolesSuccessAction, LoadRolesFailAction } from './roles.actions';
import { Injectable } from '@angular/core';
import { RolesClient } from '@core/services/api.service';

export class RolesStateModel {
  public isLoading: boolean;
  public roles: RoleModel[];
}

@State<RolesStateModel>({
  name: 'roles',
  defaults: {
    isLoading: false,
    roles: [],
  }
})
@Injectable()
export class RolesState {
  constructor(
    private rolesClient: RolesClient
  ) { }

  @Selector()
  static getIsLoading(state: RolesStateModel) {
    return state.isLoading;
  }

  @Selector()
  static getRoles(state: RolesStateModel) {
    return state.roles;
  }

  @Action(LoadRolesAction)
  loadRolesAction({ dispatch, patchState }: StateContext<RolesStateModel>, action: LoadRolesAction) {
    patchState({ isLoading: true });

    return this.rolesClient.getAll(false).pipe(
      tap((roles) => dispatch(new LoadRolesSuccessAction({ roles }))),
      catchError((err) => dispatch(new LoadRolesFailAction()))
    );
  }

  @Action(LoadRolesSuccessAction)
  LoadRolesSuccessAction(ctx: StateContext<RolesStateModel>, action: LoadRolesSuccessAction) {
    ctx.patchState({
      isLoading: false,
      roles: action.payload.roles
    });
  }

  @Action(LoadRolesFailAction)
  loadRolesFailAction(ctx: StateContext<RolesStateModel>, action: LoadRolesFailAction) {
    ctx.patchState({
      isLoading: false,
      roles: []
    });
  }
}
